import React from 'react';
import { connect } from 'react-redux';
import Gallery from './gallery/Gallery';
import ImagesDropdownNav from './gallery/ImagesDropdownNav';
import { dropdownSelection } from '../actions'
//course understanding hooks in React
//C:\UdemyReactCourse\05_Hooks\widgets\src\components
//Udemy course Hooks widgets discuss drop downs.

class Images extends React.Component {
    setSelected = (option) => {
        this.props.dropdownSelection(option);
    };
    componentDidMount() {
        console.log("Initializing Photography.Images..");
        //doing this from NavBar now
        // let imageslink = document.getElementById('images-link');
        // imageslink.className = 'dimNavLink';
    }

    render() {
        return (
            <Gallery images={this.props.dropdownImages}>
                <ImagesDropdownNav
                    label="Select a species"
                     // selected={this.props.dropdownSelection}   get rid of this, not being used
                    onSelectedChange={this.setSelected}
                    options={this.props.dropdownOptions} />
            </Gallery>
        )
    }
};


const mapStateToProps = (state) => {
    return {
        dropdownSelection: state.dropdownSelection.selection,
        dropdownImages: state.dropdownImages,
        dropdownOptions: state.dropdownOptions
    };
}
//NOTE action creator 'dropdownSelection' included here
export default connect(mapStateToProps, { dropdownSelection: dropdownSelection })(Images);